import {SmartTable} from '../../../../components/smart-table/smart-table.model';
export class Controller {

    /** @ngInject */
    constructor($state,$rootScope,  Alert,UsersSharedAccountService) {
        this.$state = $state;
        this.Alert = Alert;
		this.$rootScope = $rootScope;
		this.UsersSharedAccountService=UsersSharedAccountService;
    }

    $onInit() {
        if (!(Array.isArray(this.companies) && this.companies.length)) {
            this.$state.go('user.shared-accounts', {}, {location: 'replace'})
        }
		
        this.publicUserAccounts=null;
		this.visibilitySetting={ showOtpEnabled: false, showPasswordEnabled: false }
    }
	changeCompany(){
		 this.publicUserAccounts=null;
		 this.hasOtp=null;
	}
	goBack() {
		var goToState = this.$rootScope.transition.from();
		var theState = goToState.name;
		if (theState === "") {
			theState = goToState.url;
		}
		this.$state.go(theState);
	}
	importPasswordManagers(){
		this.publicUserAccounts=angular.copy(this.passwordManagers);
		this.st = new SmartTable();
		this.st.displayedItems=this.publicUserAccounts;
		this.hasOtp=false;
	}
	importAuthenticators(){
		this.publicUserAccounts=angular.copy(this.authenticators);
		this.st = new SmartTable();
		this.st.displayedItems=this.publicUserAccounts;
		
		this.hasOtp=true;
		
	}
	
	add(selectedPublicUserAccounts){
		this.showConfirm=true;
		this.userAccountsToShare=selectedPublicUserAccounts;
		//this.st = new SmartTable();
		//this.st.displayedItems=this.userAccountsToShare;
	}
	cancelConfirm(){
		this.showConfirm=false;
		this.userAccountsToShare=null;
	}
	goFromBegining(){
		this.$state.transitionTo(this.$state.current, {companies: this.companies}, { 
  			reload: true, inherit: false, notify: false 
		});
	}
	
	save(){
		this.isSaving = true;
		var showOtp = this.visibilitySetting.showOtpEnabled;
		var showPass = this.visibilitySetting.showPasswordEnabled;
		var companyId = this.selectedCompany.id;
		var publicUserAccountsIds = this.userAccountsToShare.map(uats => uats.id);
		this.UsersSharedAccountService.usersCompanySharedAccounts.shareAccountsWithCompany({companyId,showOtp,showPass},publicUserAccountsIds).$promise
		.then(() => {
                    this.Alert('success', 'users.public-user-accounts.share.success');
                    this.goBack();})
		.catch((error) => {
					this.Alert('danger', error.data.message);
				})
		.finally(() => this.isSaving = false);
		
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/share-public-user-account/share-public-user-account.controller.js